import * as url from 'routes/nav.routes';
import request from 'services/request';
import { DefaultDataType } from 'typings/nav.type';
import {
  checkCombinedScenario,
  getNavData,
  getStockData,
  normalizeNavSave,
  updateDividend,
} from 'utils/nav.util';

export const getNavDataAction = async (
  set,
  securityId,
  navId,
): Promise<void> => {
  set({ navDataLoading: true, navDataError: false });
  const [
    navResponse,
    parametersResponse,
    stockResponse,
    outOfExchangeResponse,
    overviewResponse,
    summaryResponse,
  ] = await Promise.all([
    request.get(url.NavDataUrl(securityId, navId)),
    request.get(url.NavParametersUrl(securityId, navId)),
    request.get(url.NavStockUrl(securityId, navId)),
    request.get(url.NavOutOfExchangeUrl(securityId, navId)),
    request.get(url.NavOverviewUrl(securityId, navId)),
    request.get(url.NavSummaryUrl(securityId)),
  ]);
  if (
    navResponse.ok &&
    overviewResponse.ok &&
    summaryResponse.ok &&
    parametersResponse.ok &&
    outOfExchangeResponse.ok &&
    stockResponse.ok
  ) {
    const navData = navResponse.data.data;
    const stock = getStockData(
      stockResponse.data.data,
      navData.stock_portfolios,
      checkCombinedScenario(navData),
    );
    const outOfExchange = getStockData(
      outOfExchangeResponse.data.data,
      navData.out_of_exchange_portfolios,
      checkCombinedScenario(navData),
    );

    set({
      navDataLoading: false,
      navData: getNavData(navData, overviewResponse.data.data),
      navParameters: parametersResponse.data.data.parameters,
      stock,
      outOfExchange,
      summaryData: summaryResponse.data.data,
      defaultData: navData.is_default
        ? { stock: [...stock], outOfExchange: [...outOfExchange] }
        : null,
      navDataError: false,
    });
  } else set({ navDataLoading: false, navDataError: true });
};

export const getWatchDataAction = async (set, isNav): Promise<void> => {
  set({ watchLoading: true, watchError: false });
  const response = await request.get(url.NavWatchUrl(isNav));
  set({ watchLoading: false, watchError: !response.ok });
  if (response.ok) {
    isNav
      ? set({ navWatchData: response.data.data })
      : set({ epsWatchData: response.data.data });
  }
};

export const putChangedFormulaAction = async (
  set,
  stock,
  outOfExchange,
  navData,
): Promise<void> => {
  set({ changeFormulaLoading: true, changeFormulaError: false });
  const body = normalizeNavSave(stock, outOfExchange, navData);
  const id = navData.security;
  const response = await request.put(url.NavChangeFormulaUrl(id), body);

  set({ changeFormulaLoading: false, changeFormulaError: !response.ok });
  if (response.ok) {
    const { nav_eps_values, navdamental_analysis } = response.data.data;
    const newStock = updateDividend(
      stock,
      navdamental_analysis.stock_portfolios,
    );
    const newOutOfExchange = updateDividend(
      outOfExchange,
      navdamental_analysis.out_of_exchange_portfolios,
    );
    set({
      navParameters: nav_eps_values,
      stock: newStock,
      outOfExchange: newOutOfExchange,
    });
  }
};

export const getDefaultDataAction = async (
  set,
  securityId,
  navId,
  defaultStatus,
): Promise<DefaultDataType> => {
  const [navResponse, stockResponse, outOfExchangeResponse] = await Promise.all(
    [
      request.get(
        defaultStatus // create new analysis if defaultStatus===false
          ? url.NavDataUrl(securityId, null)
          : url.NavNewFinancialYearUrl(securityId),
      ),
      request.get(url.NavStockUrl(securityId, null)),
      request.get(url.NavOutOfExchangeUrl(securityId, navId)),
    ],
  );
  if (navResponse.ok && outOfExchangeResponse.ok && stockResponse.ok) {
    const navData = navResponse.data.data;
    const stock = getStockData(
      stockResponse.data.data,
      navData.stock_portfolios,
      checkCombinedScenario(navData),
    );
    const outOfExchange = getStockData(
      outOfExchangeResponse.data.data,
      navData.out_of_exchange_portfolios,
      checkCombinedScenario(navData),
    );
    const defaultData = { stock, outOfExchange };
    set({ defaultData });
    return defaultData;
  }
  return null;
};
